import { useNavigate } from "react-router-dom";
import { useState } from "react"; // Added for animation state

const WhySemarsHoldings = () => {
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false); // Added state for animation

  const stats = [
    {
      value: "20+",
      description: "Years of Market Experience",
    },
    {
      value: "100+",
      description: "Expert Members",
    },
    {
      value: "15+",
      description: "Active Countries",
    },
    {
      value: "10+",
      description: "Professional Awards",
    },
    {
      value: "2017",
      description: "Since 2017",
    },
    {
      value: "1,200+",
      description: "Clients Served",
    },
    {
      value: "24/7",
      description: "Support Available",
    },
    {
      value: "5 billion+",
      description: "Investment Opportunities",
    },
  ];

  // Enhanced navigation function with animation and scroll to top
  const handleConsultationClick = () => {
    setIsNavigating(true);
    
    // Add a slight delay for visual feedback
    setTimeout(() => {
      navigate('/contact');
      // Scroll to top after navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }, 300);
  };

  return (
    <section className="bg-[#040404] min-h-[70vh]">
      <div className="flex justify-center pt-6 space-x-4">
        <button
          onClick={handleConsultationClick}
          disabled={isNavigating}
          type="button"
          className={`bg-[#C99C48] hover:bg-[#B8914A] text-white font-medium py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 active:scale-95 ${
            isNavigating ? 'opacity-70 scale-95 cursor-not-allowed' : ''
          }`}
        >
          <span>{isNavigating ? 'Getting consultation...' : 'Get a consultation'}</span>
        </button>
        <button
          type="button"
          onClick={() => navigate('/services')}
          className={`bg-transparent border-2 border-white hover:bg-white hover:text-black text-white font-medium py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 active:scale-95 ${
            isNavigating ? 'opacity-70 scale-95 cursor-not-allowed' : ''
          }`}
        >
          <span>{isNavigating ? 'Navigating...' : 'Explore Services'}</span>
        </button>
      </div>
      <div className="flex items-center py-12 md:py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16 md:mb-24">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white">
              Why Semars Holding?
            </h2>
          </div>

          <div className="max-w-6xl mx-auto" data-aos="fade-up">
            <div className="block md:hidden space-y-8">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="text-center py-6 border-b border-[#C99C48] last:border-b-0 group cursor-pointer"
                >
                  <div className="text-3xl md:text-4xl font-bold text-white mb-3 transition-all duration-300 ease-in-out group-hover:text-[#C99C48] group-hover:scale-110 group-hover:drop-shadow-[0_0_15px_rgba(201,156,72,0.5)]">
                    {stat.value}
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed max-w-xs mx-auto transition-all duration-300 ease-in-out group-hover:text-[#C99C48] group-hover:scale-105 group-hover:drop-shadow-[0_0_10px_rgba(201,156,72,0.4)]">
                    {stat.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="hidden md:grid grid-cols-4 divide-x divide-[#C99C48]">
              {stats.slice(0, 4).map((stat, index) => (
                <div key={index} className="text-center py-8 px-6 group cursor-pointer">
                  <div className="text-4xl lg:text-5xl font-bold text-white mb-4 transition-all duration-300 ease-in-out group-hover:text-[#C99C48] group-hover:scale-110 group-hover:drop-shadow-[0_0_20px_rgba(201,156,72,0.6)] transform">
                    {stat.value}
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed transition-all duration-300 ease-in-out group-hover:text-[#C99C48] group-hover:scale-105 group-hover:drop-shadow-[0_0_12px_rgba(201,156,72,0.4)]">
                    {stat.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="hidden md:block border-t border-[#C99C48]"></div>

            <div className="hidden md:grid grid-cols-4 divide-x divide-[#C99C48]">
              {stats.slice(4, 8).map((stat, index) => (
                <div key={index + 4} className="text-center py-8 px-6 group cursor-pointer">
                  <div className="text-4xl lg:text-5xl font-bold text-white mb-4 transition-all duration-300 ease-in-out group-hover:text-[#C99C48] group-hover:scale-110 group-hover:drop-shadow-[0_0_20px_rgba(201,156,72,0.6)] transform">
                    {stat.value}
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed transition-all duration-300 ease-in-out group-hover:text-[#C99C48] group-hover:scale-105 group-hover:drop-shadow-[0_0_12px_rgba(201,156,72,0.4)]">
                    {stat.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySemarsHoldings;